module.exports = __webpack_public_path__ + "img/t6-purple.a5d0eb7a.png";